"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToogleEnableUser = void 0;
const react_1 = __importStar(require("react"));
const CustomPagination_1 = require("../../../Common/CustomPagination");
const react_bootstrap_table_next_1 = __importDefault(require("react-bootstrap-table-next"));
const ai_1 = require("react-icons/ai");
const fa_1 = require("react-icons/fa");
const react_router_dom_1 = require("react-router-dom");
const user_api_1 = require("../../../../utils/api/user/user.api");
const EmptyAlert_1 = __importDefault(require("../../../Shared/Alerts/EmptyAlert"));
const TableSkeleton_1 = __importDefault(require("../../AdminShared/TableSkeleton"));
const UseCrudAdmin_1 = require("../../ParametresAdmin/requestForm/UseCrudAdmin");
const react_switch_1 = __importDefault(require("react-switch"));
const UseEnableOrDisable_1 = require("../requestForm/UseEnableOrDisable");
const DeleteUserButton = ({ id }) => {
    const onDelete = (0, UseCrudAdmin_1.useDeleteUser)(id);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { className: "btn with-tooltip btn-action-icon-delete", "data-tooltip-content": "Supprimer", style: { color: "#E53E3E" }, onClick: () => onDelete() },
            react_1.default.createElement(fa_1.FaTrash, null))));
};
const ShowUserButton = ({ item }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_router_dom_1.NavLink, { to: `/admin/utilisateurs/${item.user_id}`, className: "btn btn-action-modal-icon with-tooltip", "data-tooltip-content": "Voir", state: item },
            react_1.default.createElement(ai_1.AiFillEye, null))));
};
const ToogleEnableUser = ({ item }) => {
    const onToogle = (0, UseEnableOrDisable_1.UseEnableOrDisableUser)(item);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_switch_1.default, { checked: !!(item === null || item === void 0 ? void 0 : item.is_active), onChange: () => onToogle(), handleDiameter: 12, height: 18, width: 34, offHandleColor: "#4B4B4B", onHandleColor: "#0288D1", offColor: "#F9FAFB", onColor: "#F9FAFB", uncheckedIcon: false, checkedIcon: false, boxShadow: "none", activeBoxShadow: "none", className: "custom-switch", id: "custom-switch-id" })));
};
exports.ToogleEnableUser = ToogleEnableUser;
const UtilisateursAdminTable = ({ search, selectedCategory }) => {
    const [page, setPage] = (0, react_1.useState)(1);
    const [perPage, setPerPage] = (0, react_1.useState)(10);
    const { data, isLoading } = (0, user_api_1.useGetListUserMobileQuery)({
        page: page,
        limit: perPage,
        word: search,
    });
    const actionFormatter = (cell, row) => {
        return (react_1.default.createElement("div", { className: "table-actions-btn-container-commandes d-flex justify-content-start gap-3" },
            react_1.default.createElement("div", { className: "container-btn-action-icon-modal d-flex justify-content-center" },
                react_1.default.createElement(ShowUserButton, { item: row })),
            react_1.default.createElement(DeleteUserButton, { id: row === null || row === void 0 ? void 0 : row.user_id })));
    };
    const sosCounterFormatter = (cell, row) => {
        return ((row === null || row === void 0 ? void 0 : row.sos_count) ? row === null || row === void 0 ? void 0 : row.sos_count : 0);
    };
    const columns = [
        {
            dataField: "fullname",
            text: "Nom de l’utilisateur",
            headerStyle: () => {
                return {
                    width: "300px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "phone",
            text: "N° TÉLÉPHONE",
            headerStyle: () => {
                return {
                    width: "200px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "sos",
            text: "SOS",
            headerStyle: () => {
                return {
                    width: "100px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
            formatter: sosCounterFormatter
        },
        {
            dataField: "is_active",
            text: `Actif`,
            formatter: (cell, row) => react_1.default.createElement(exports.ToogleEnableUser, { item: row }),
            headerStyle: () => {
                return {
                    width: "150px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "id",
            text: "Action",
            formatter: actionFormatter,
            headerStyle: () => {
                return {
                    width: "150px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
    ];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !!isLoading && react_1.default.createElement(TableSkeleton_1.default, { headers: columns }),
        !isLoading && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "col-lg-12" },
                react_1.default.createElement("div", { className: "admin-table" },
                    react_1.default.createElement(react_bootstrap_table_next_1.default, { keyField: "user_id", data: (data === null || data === void 0 ? void 0 : data.data) || [], columns: columns, condensed: true, hover: true, wrapperClasses: "table-responsive admin-table", noDataIndication: () => (react_1.default.createElement(EmptyAlert_1.default, { textualContent: "Aucune donn\u00E9es trouv\u00E9es" })) }),
                    react_1.default.createElement("div", { className: "custom-pagination-container" },
                        react_1.default.createElement(CustomPagination_1.CustomPagination, { nbPages: data === null || data === void 0 ? void 0 : data.count, page: page, onChange: (page, perPage) => {
                                setPerPage(perPage);
                                setPage(page);
                            }, perPage: perPage }))))))));
};
exports.default = UtilisateursAdminTable;
